import React, { createContext, useContext, useState, useEffect } from 'react';
import { loadingManager } from '../Utils/loadingManager';

const LoadingContext = createContext();

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};

export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Subscribe to loading state changes from loadingManager
    const unsubscribe = loadingManager.subscribe((isLoading) => {
      setLoading(isLoading);
    });

    // Cleanup subscription on unmount
    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <LoadingContext.Provider value={{ loading }}>
      {children}
    </LoadingContext.Provider>
  );
};
